import { apiClient } from "./client";

export const signup = (data) => apiClient.post("/auth/signup", data).then((r) => r.data);
export const login = (data) => apiClient.post("/auth/login", data).then((r) => r.data);
